import { Extras, Lines, Prices, Vis, ExtraLines } from "../@types/Data";
import Moment from 'moment';

const payloadBase = '{    "numero": "",    "datebook": "",    "datecheck": "",    "user_id": 0,    "username": "marketingpyme",    "netAmount": -1,    "discount": 0,    "taxAmount": -1,    "taxName": "IVA 10%",    "total": -1,    "terminal": "web",     "daterefund": null,    "userRefund": null,    "operationLine_id": -1,    "operationLineName": "",    "businessUnitName": "",    "tin": "",    "stretch_id": -1,    "stretchName": "",    "datevalited": null,    "codeDiscount": null,    "vuelta": false,    "printPrice": true,    "numberPrinted": 1,    "numberScanned": 0,    "hoponHopoff": false,    "tramoHora": true,    "timeExpiration": -1,    "timeAdvance": -1,   "tramoHoraVuelta": false,    "origin": "",    "destination": "",    "timeDelay": -1,    "timeUse": -1,    "aditionalInfo": "",    "totalDiscount": 0,    "typeDiscount": "fix",    "receiptLayout_id": 1,    "discountReason": null,   "extraLines": [],    "lines": [],    "payments": [        {            "method": "card",            "afiliate_id": null,            "afiliateName": null,            "afiliateTypeCommission": null,            "afiliateCommission": null,            "amount": -1        }    ]}'

const mountLines = (prices: Prices[], visitas: Vis, taxValue: number, taxName: string, tax_id: number): Lines[] => {
    const lines: Lines[] = [];

    prices.forEach((precio) => {
        const index = prices.indexOf(precio);
        const quantity = visitas.vis[index];
        const taxBase = (quantity * precio.price).toFixed(2);
        const taxAmount = (+taxBase * taxValue).toFixed(2);
        lines.push({
            price: precio.price,
            discount: 0,
            quantity: quantity,
            taxBase: +taxBase,
            taxAmount: +taxAmount,
            taxValue: taxValue,
            tax_id: tax_id,
            taxName: taxName,
            total: (+taxBase )+ (+taxAmount),
            passengerCategory_id: precio.passengerCategory.id,
            passengerCategoryName: precio.passengerCategory.name,
        });
    });

    return lines;
}

const mountExtraLines = (extras: Extras[]) => {
    const extraLines: ExtraLines[] = [];
    extras.forEach((extra) => {
        extraLines.push({
            price: +extra.price.toFixed(2),
            extra_id: extra.id,
            extraName: extra.name,
            description: extra.description,
            quantity: extra.quantity,
            taxBase: extra.price,
            taxAmount: extra.price * extra.tax.value,
            tax_id: extra.tax_id,
            taxName: extra.tax.name,
            taxValue: extra.tax.value,
            total: +(extra.price + extra.price * extra.tax.value).toFixed(2)
        });
    });
    return extraLines;
}

export const mountPayload = (qrTicket: string, selectedDate: string, selectedHour: string, netAmount: number, taxValue: number, taxName: string, operationLine_id: number, 
    operationLineName: string, businessUnitName: string, tin: string, stretch_id: number, stretchName: string, vuelta: boolean, hoponHopoff: boolean,
    tramoHora: boolean, timeExpiration: number, timeAdvance: number, tramoHoraVuelta: boolean, origin: string, destination: string, timeDelay: number,
    timeUse: number, aditionalInfo: string, amount: number, prices: Prices[], visitas: Vis, tax_id: number, extras: Extras[]) => {
    
        const payload = JSON.parse(payloadBase);
        const taxAmount = netAmount * taxValue;
        const total = visitas.total.toFixed(2);
        const datebook = (selectedDate !== "" && selectedHour !== "") ? Moment(selectedDate).format("YYYY-MM-DD") + "T" + Moment(selectedHour, "HHmmss").format('HH:mm:ssZ') : Moment(new Date()).format();

        payload.numero = qrTicket;
        payload.datebook = datebook;
        payload.datecheck = Moment(new Date()).format();
        payload.netAmount = netAmount;
        payload.taxAmount = taxAmount;
        payload.taxName = taxName;
        payload.total = +total;
        payload.operationLine_id = operationLine_id;
        payload.operationLineName = operationLineName;
        payload.businessUnitName = businessUnitName;
        payload.tin = tin;
        payload.stretch_id = stretch_id;
        payload.stretchName = stretchName;
        payload.vuelta = vuelta;
        payload.hoponHopoff = hoponHopoff;
        payload.tramoHora = tramoHora;
        payload.timeExpiration = timeExpiration;
        payload.timeAdvance = timeAdvance;
        payload.tramoHoraVuelta = tramoHoraVuelta;
        payload.origin = origin;
        payload.destination = destination;
        payload.timeDelay = timeDelay;
        payload.timeUse = timeUse;
        payload.aditionalInfo = aditionalInfo;
        payload.lines = mountLines(prices, visitas, taxValue, taxName, tax_id);
        payload.payments[0].amount = amount;     
        payload.extraLines = mountExtraLines(extras);   
        return payload;
}

const randomString = (length: number, chars: string) => {
    let result = '';
    for(let i = length; i > 0; i--) result += chars[Math.floor(Math.random() * chars.length)]
    return result;
}

export const generateTokenticket = (numChars: number) => {
    return randomString(numChars, '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ');
}

export const primeraLetraMayuscula = (cadena: string) => {
    const primerCaracter = cadena.charAt(0).toUpperCase();
    const restoDeLaCadena = cadena.substring(1, cadena.length);
    return primerCaracter.concat(restoDeLaCadena);
};

export const validarTelefono = () => {

}